<template>
  <div class="piggery bg-white">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1 class="fs-90">万物互联 数据互通</h1>
    </div>
    <div class="middle-content iot-detail">
      <aside class="iot-menu">
        <h2 class="canClick" @click="goBack">产品中心</h2>
        <ul>
          <li v-for="item in allHardwareList" :key="item.typeId" @click="handelSelect(item)" :class="{active: typeIdKey === item.typeId}">{{item.typeName}}</li>
        </ul>
      </aside>
      <div class="h600">
        <section>
        <div class="content">
          <div>
          <div class="type">
            <h3>{{typeName}}</h3>
          </div>
          <ul class="hardware-box">
          <li class="box canClick" v-for="iitem in hardwareList" :key="iitem.hardwareId" @click="toConnection(iitem)">
            <div class="box-item" :style="`background-image:url(${iitem.pictureUrl})`"></div>
            <div class="detail">
              <span>{{iitem.hardwareName}}</span>
            </div>
          </li>
          </ul>
          <div style="clear:both"></div>
          </div>
        </div>
      </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'iotDetail',
  data () {
    return {
      query: this.$route.query,
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      allHardwareList: [],
      hardwareList: [],
      typeIdKey: '',
      typeName: ''
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').internet_things
    }
    this.typeIdKey = this.query.typeId
    this.typeName = this.query.typeName
    this.listAllHardware()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.internet_things
      setSession('bannerPic', arr)
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    },
    /** 切换产品标签 */
    handelSelect (item) {
      this.typeIdKey = item.typeId
      this.typeName = item.typeName
      var arr = item.hardwareViewDTOList
      this.hardwareList = arr.sort((a, b) => { return a.sortValue - b.sortValue })
    },
    listAllHardware () {
      this.API.recruit.listAllHardware().then((res) => {
        this.allHardwareList = res.data || []
        this.allHardwareList.forEach((item) => {
          if (this.typeIdKey === item.typeId) {
            var arr = item.hardwareViewDTOList
            this.hardwareList = arr.sort((a, b) => { return a.sortValue - b.sortValue })
          }
        })
      })
    },
    toConnection (iitem) {
      if (!iitem.connection) {
        return ''
      }
      window.open(iitem.connection)
    },
    goBack () {
      this.$router.push({
        name: 'iot'
      })
    }
  }
}
</script>
